import { z } from 'zod';
/**
 * Alliances (ADR 0068 §5): two parties joined for Shefira's raid, ten at
 * most, by their leaders' choice. A leader names the other party's leader,
 * who answers; either leader ends it. Neither party changes: an alliance
 * only says whose raid it is. The server keeps it and tells both parties.
 */
const CharacterIdSchema = z.string().min(1).max(64);
/** A party's leader names the leader of the party to ally with. */
export const AllianceInviteMessageSchema = z.object({ name: z.string().trim().min(1).max(32) });
/** Answer the offer of `from` (a character id, as `alliance_invited` gave it). */
export const AllianceAnswerMessageSchema = z.object({
    from: CharacterIdSchema,
    accept: z.boolean(),
});
/** Either leader ends the alliance. */
export const AllianceLeaveMessageSchema = z.object({}).strict();
/** To every member of both parties after each change; empty `parties` when none. */
export const AllianceStateSchema = z
    .object({
    parties: z
        .array(z.object({
        leaderId: CharacterIdSchema,
        leader: z.string().min(1),
        members: z.array(z.string().min(1)).max(5),
    }))
        .max(2),
})
    .strict();
/** To the leader it is offered to. */
export const AllianceInvitedSchema = z
    .object({
    from: CharacterIdSchema,
    name: z.string().min(1),
    expiresInMs: z.number().int().min(0),
})
    .strict();
export const AllianceEventSchema = z
    .object({
    kind: z.enum(['invited', 'formed', 'declined', 'expired', 'dissolved']),
    /** The other leader. */
    name: z.string().min(1),
})
    .strict();
export const AllianceRejectedSchema = z
    .object({
    reason: z.enum([
        'invalid',
        'not-leader',
        'not-found',
        'self',
        'target-not-leader',
        'already-allied',
        'too-many',
        'no-invite',
        'not-allied',
        'pending',
    ]),
})
    .strict();
//# sourceMappingURL=alliance.js.map